import { OpenAPI as KeymasterV2API, AccessTokenDetails, AccessTokenVService, MeVService } from './V2/keymaster';
import { OpenAPI as GozerV2API } from './V2/gozer';
import { OpenAPI as GozerV3API } from './V3/gozer';
import { OpenAPI as PadreV2API } from './V2/padre';
import { OpenAPI as LonghornV2API } from './V2/longhorn';
import { OpenAPI as LonghornV3API } from './V3/longhorn';
import { getOperatorId, removeData, retrieveData, storeData } from '../components/Shared/Functions';

let _accessToken: AccessTokenDetails | undefined = undefined;
let _refreshTimer: ReturnType<typeof setTimeout> | undefined = undefined;

/* API configuration */

KeymasterV2API.BASE = ""
PadreV2API.BASE = ""
GozerV2API.BASE = ""
GozerV3API.BASE = ""
LonghornV2API.BASE = ""
LonghornV3API.BASE = ""

function decodeJWTClaims({ token }: AccessTokenDetails) {
    if (!token) return {};
    const parts = token.split('.');
    if (parts.length < 2) return {};

    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4 !== 0) payload += '=';

    try {
        return JSON.parse(atob(payload));
    } catch {
        return {};
    }
}

function refreshTime(timeString: string) {
    const time = new Date(timeString);
    const millisRemaining = time.getTime() - Date.now()
    return millisRemaining - 5000;
}
function refreshToken() {
    if (_accessToken) {
        AccessTokenVService
            .accessTokenVRefreshAccessToken({ refreshToken: _accessToken.refreshToken ?? "" })
            .then((accessToken: AccessTokenDetails) => {
                let timeoutMs = refreshTime(accessToken.tokenExpires ?? Date.now().toString())
                if (accessToken.token === _accessToken?.token) {
                    console.warn("Refresh token called, but no new refresh token given");
                }
                _accessToken = accessToken;

                // Saftey net to prevent infinite loop
                if (timeoutMs > 1000) {
                    _refreshTimer = setTimeout(refreshToken, timeoutMs);
                }
            })
            .catch(() => _accessToken = undefined)
    }

}
/* Always get latest token from NexusAuthprovider */

KeymasterV2API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}
PadreV2API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}
GozerV2API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}
GozerV3API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}
LonghornV2API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}
LonghornV3API.TOKEN = async () => {
    return _accessToken && _accessToken.token ? _accessToken.token : ""
}

async function login(user): Promise<string> {

    let _getToken = (resolve, reject) => {
        removeData("billingAccount")
        getOperatorId()
            .then((x:any) => {
                AccessTokenVService
                    .accessTokenVCreateAccessToken({
                        username: user.username,
                        password: user.password,
                        operatorId: x
                    })
                    .then((accessToken: AccessTokenDetails) => {
                        let timeoutMs = refreshTime(accessToken.tokenExpires ?? Date.now().toString())
                        storeData("token", accessToken.refreshToken);
                        _accessToken = accessToken;
                        if (timeoutMs > 1000) {
                            _refreshTimer = setTimeout(refreshToken, timeoutMs);
                        }
                        resolve(accessToken.token);
                    })
                    .catch(err => reject(err))
            })
    }
    return new Promise<string>(_getToken);
}

async function updateUser(user): Promise<boolean> {
    let _createUser = (resolve: (arg: boolean) => void,
        reject: (arg: Error) => void) => {
        resolve(true);
    }

    return new Promise(_createUser);
}


function getUser(): Promise<any> {
    if (_accessToken) {

        let claims = decodeJWTClaims(_accessToken)
        let user: any = {
            id: claims.UserId,
            username: claims.Username,
            accounts: []
        }

        const _getUser = (resolve, reject) => {
            MeVService.meVGetMe()
                .then((keymasterUser) => {
                    user.name = keymasterUser.name;
                    user.email = keymasterUser.email;
                    user.username = keymasterUser.username;
                    resolve(user)
                })
                .catch(err => reject(err))
        }
        return new Promise(_getUser);
    } else {
        throw Error("Unauthorized")
    }
}

async function isAuthed() {
    const token = retrieveData("token")
    const _sessionLogin = resolve => {
            AccessTokenVService
                .accessTokenVRefreshAccessToken({ refreshToken: token ?? "" })
                .then(accessToken => {
                    let timeoutMs = refreshTime(accessToken.tokenExpires ?? Date.now().toString())
                    _accessToken = accessToken;
                    if (timeoutMs > 1000) {
                        _refreshTimer = setTimeout(refreshToken, timeoutMs);
                    }
                    resolve(true);
                })
                .catch(err => resolve(false))
    }

    if( _accessToken ) {
        return Promise.resolve(true);
    } else if (token ) {
        return new Promise(_sessionLogin);
    } else {
        return Promise.resolve(false);
    }
}

async function logout() {
    removeData("token")
    removeData("billingAccount")
    _accessToken = undefined;
    _refreshTimer && clearTimeout(_refreshTimer);
}

function getToken(): string {
    return _accessToken && _accessToken.token ? _accessToken.token : "";
}


export {
    login, logout, getUser, updateUser, getToken, isAuthed
}
